import { inject, Injectable } from '@angular/core';
import {
  AuthenticatedIdentity,
  AuthenticationService,
  LogoutOption,
} from './authentication.service';
import { AuthService } from '@auth0/auth0-angular';
import { filter, map, Observable, switchMap, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Auth0AuthenticationService implements AuthenticationService {
  auth0 = inject(AuthService);

  claims$ = this.auth0.idTokenClaims$;
  identity$ = this.auth0.user$.pipe(
    map(
      (user) =>
        ({
          kind: 'auth0',
          sub: user?.sub,
        }) as AuthenticatedIdentity
    )
  );
  isAuthenticated$ = this.auth0.isAuthenticated$;

  getAccessTokenSilently(forceRefresh = false): Observable<string> {
    return this.auth0.isLoading$.pipe(
      filter((isLoading) => !isLoading),
      take(1),
      // ignoreCache forces a network refresh (#31749); undefined keeps the
      // cache-first default so pre-existing callers are byte-identical.
      switchMap(() =>
        this.auth0.getAccessTokenSilently(
          forceRefresh ? { ignoreCache: true } : undefined
        )
      )
    );
  }

  logout(options: LogoutOption): void {
    return this.auth0.logout(options);
  }
}
